import Cookies from 'js-cookie';
import {
  SS_MARKETING_COOKIES,
  TRACKING_USER_PARAMS_COOKIE,
} from '../constants';
import { useTrackingUserParamsStore } from '../store';
import { getAffiliateParams } from './getAffiliateParamsHelper';
import { getTrackingUserParamsCookie } from './getTrackingUserParamsCookieHelper';

/** Domains a cookie could be scoped to: host-only (undefined) plus each parent. */
export const getRemovalDomains = (hostname: string): (string | undefined)[] => {
  const labels = hostname.split('.');
  const domains: (string | undefined)[] = [undefined];

  for (let i = 0; i < labels.length - 1; i++) {
    domains.push(`.${labels.slice(i).join('.')}`);
  }

  return domains;
};

/** Drops campaign attribution — `sign_out` leaves it to the next account (DEV-1636). */
export const clearMarketingAttribution = () => {
  if (typeof window === 'undefined') return;

  const storedParams = getTrackingUserParamsCookie();
  const preservedParams = storedParams ? getAffiliateParams(storedParams) : {};

  const removalOptions = getRemovalDomains(window.location.hostname).map(
    (domain) => ({ path: '/', ...(domain && { domain }) })
  );

  [...SS_MARKETING_COOKIES, TRACKING_USER_PARAMS_COOKIE].forEach((name) => {
    removalOptions.forEach((options) => {
      Cookies.remove(name, options);
    });
  });

  if (Object.keys(preservedParams).length > 0) {
    Cookies.set(TRACKING_USER_PARAMS_COOKIE, JSON.stringify(preservedParams));
  }

  useTrackingUserParamsStore.getState().resetCampaignParams();
};
